module.exports = __webpack_public_path__ + "images/marketing/smart-selling-award.png";